import { call, put, takeEvery } from 'redux-saga/effects';
import { CAR_LIST_REQUEST, FILTER_CARS_REQUEST } from './actionTypes';
import {
  carListSuccess,
  carListFailure,
  getFilteredCarsSuccess,
  getFilteredCarsFailure,
} from './actions';
import CarService from '../../services/CarService';

export function* getCars(action) {
  try {
    const result = yield call(CarService.getCarCards, action.payload);
    yield put(carListSuccess(result));
  } catch (error) {
    yield put(carListFailure(error));
  }
}

export function* getFilteredCarsRequest(action) {
  try {
    const result = yield call(CarService.getFilteredCards, action.payload);
    yield put(getFilteredCarsSuccess(result));
  } catch (error) {
    yield put(getFilteredCarsFailure(error));
  }
}

export function* carsSaga() {
  yield takeEvery(CAR_LIST_REQUEST, getCars);
  yield takeEvery(FILTER_CARS_REQUEST, getFilteredCarsRequest);
}
